import { Component, OnInit } from '@angular/core';
import { AbstractStatsService } from '@app/Services/statistics/abstract.stats.service';
import { label } from '../constants/labels';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts/highstock';
import { MessageService } from 'primeng/api';
import { IAlarmsByDeviceStatusFilter, IDateFilter } from '@app/Models/IStatistics';
import { DatePipe } from '@angular/common';
import { UtilService } from '../Services/util.service';
import { IGridCols, IKeyValuePair } from '../Models/IGridCols';
import { IDeviceList, IDropdownConfig } from '../Models/IDeviceMetadata';
import { IDeviceNames } from '../Models/IControllerNames';
import { IDeviceGroup } from '../Models/IDeviceGroup';
import { I18nService } from '../core/i18n.service';



@Component({
  selector: 'app-statistics',
  standalone: false,
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  providers: [MessageService]
})

export class StatisticsComponent implements OnInit {
  deviceStatusTitle: string;
  columnChart: any;
  pieChart: any;
  distributionChart: any;
  stockChart: any;
  alarmsData: any[];
  isPagination: boolean = false;
  noDataAlarmInfo: boolean = false;
  noDataDeviceGroupGridInfo: boolean = false;
  isDeviceGroupPagination: boolean = false;
  deviceAlarmCols: Array<IGridCols>;
  deviceGroupCols: Array<IGridCols>;
  labels: any = label;
  deviceCount: {};
  alarmCount: {};
  isGroupModalLoading: boolean = false;
  deviceStatusValueLabels: Array<IKeyValuePair>;
  deviceStatusCount: IKeyValuePair;
  deviceStatusData: Array<IKeyValuePair>;
  selectedDeviceStatus: number;
  deviceGroupNames: any[] = [];
  contrlModels: any[] = [];
  selectedDeviceGroup: any[] = [];
  deviceGroupCount: {};
  isLoading: boolean = false
  deviceByGroupCount: any;
  colChrtDtRng: any[];
  distriChrtDtRng: any[];
  colChrtslctedDtRng: number = 365;
  pieChrtslctedDtRng: number = 365;
  distChrtslctedDtRng: number = 0;
  deviceStatusCountBarconfig: Highcharts.Options;
  deviceByGroupPieChartConfig: Highcharts.Options;
  AlarmsCountByDistriConfig: Highcharts.Options;
  drpdwnGroupListConfig: IDropdownConfig;
  drpdwnCntrlModelListConfig: IDropdownConfig;
  alarmsByDeviceStockConfig: Highcharts.Options;
  showInfoDialog: boolean = false;
  showGroupDeviceInfoDialog: boolean = false;
  deviceCountWLoader: boolean = false;
  deviceCountStatusWLoader: boolean = false;
  groupCountWLoader: boolean = false;
  deviceFilter: IAlarmsByDeviceStatusFilter;
  dateFilter: IDateFilter;
  colChartClick: boolean = false;
  selectedcontrlModel: any[] = [];
  alarmDistributionData: any;
  status = [{
    id: 1,
    status: "Critical",
    color: '#F92E02'
  },
  {
    id: 2,
    status: "Warning",
    color: '#F5F902'
  },
  {
    id: 3,
    status: "Clear",
    color: '#B9B9B5'
  }];
  SelectedDeviceName: string = '';
  SelectedSeverityName: string = '';
  stockChartClick: boolean = false;
  pieChartClick: boolean = false;
  GroupDetailsList: Array<IDeviceGroup> = [];
  isGroupPagination: boolean = false;
  coolersData: Array<IDeviceList>;
  deviceCols: Array<IGridCols>;
  deviceList: Array<IDeviceNames> = [];
  selectedStockChartDate: Date;
  isDialogLoading: boolean = false;
  constructor(private readonly statsService: AbstractStatsService, public datepipe: DatePipe,private readonly translate: TranslateService, private  i18nService: I18nService) {
    this.i18nService.componentMethodCalled$.subscribe(
      () => {     
        this.CreateAllCharts();
      }
    );
  }
  
  ngOnInit(): void {

    this.deviceAlarmCols = [
      { field: 'deviceName', header: this.translate.instant(this.labels.tableHeaderDevice), width: '20%', display: 'auto' },
      { field: 'locationCountry', header: this.translate.instant(this.labels.tableHeaderCountry), width: '20%', display: 'auto' },
      { field: 'startedOn', header: this.translate.instant(this.labels.tableHeaderStart), width: '12%', display: 'auto' }, //TBD
      { field: 'endedOn', header: this.translate.instant(this.labels.tableHeaderEnd), width: '15%', display: 'auto' },
      { field: 'isActive', header: this.translate.instant(this.labels.tableHeaderDeviceStatus), width: '15%', display: 'auto' }, //TBD
      { field: 'severity', header: this.translate.instant(this.labels.alarmType), width: '15%', display: 'none' },
      { field: 'ruleIdName', header: this.translate.instant(this.labels.tableHeaderRule), width: '15%', display: 'auto' },
      { field: 'resourceName', header: this.translate.instant(this.labels.tableHeaderResource), width: '15%', display: 'auto' }
    ];
    this.deviceCols = [
      { header: '#', width: '5%', display: 'auto', showInMobileView: false },
      { field: 'name', header: this.translate.instant( this.labels.tableHeaderDevice), width: '18%', display: 'auto', showInMobileView: true },
      {
        field: 'lastConnectedOn', header: this.translate.instant( this.labels.tableHeaderLastConnect), width: '19%', display: 'auto', showInMobileView: true
      },
      { field: 'deviceStatus', header: this.translate.instant(this.labels.tableHeaderDeviceStatus), width: '20%', display: 'auto', showInMobileView: true },
    ];
    this.deviceGroupCols = [
      { field: 'id', display: 'none' },
      { field: 'name', header: this.translate.instant(this.labels.tableHeaderDevice), display: 'auto' },
      { field: 'desc', header: this.translate.instant(this.labels.dgTblHeaderDescription), display: 'auto' },
      { field: 'addedBy', header: this.translate.instant(this.labels.dgTblHeaderAddedBy), display: 'auto' },
      { field: 'addedOn', header: this.translate.instant(this.labels.addedOn), display: 'auto' },
      { field: 'deviceIds', header: this.translate.instant(this.labels.statDeviceCountTitle), display: 'none' },
      { field: 'deviceCount', header: this.translate.instant(this.labels.statDeviceCountTitle), display: 'auto' },
     
    ];
    this.drpdwnGroupListConfig = {
      displayFn: (item: any) => { return this.translate.instant(item.name); },
      displayKey: 'name',
      search: true,
      height: '200px',
      placeholder: "Select group",
      showSelectedItems: false
    }
    this.drpdwnCntrlModelListConfig = {
      displayFn: (item: any) => { return this.translate.instant(item.name); },
      displayKey: 'name',
      search: true,
      height: '200px',
      placeholder: "Select controller model",
      showSelectedItems: false
    }
    this.deviceStatusData = this.statsService.deviceStatusData;
    this.deviceStatusValueLabels = this.statsService.deviceStatusValueLabels;
    this.colChrtDtRng = this.statsService.deviceStatusCountDateRangeLabelsColumn;
    this.distriChrtDtRng = this.statsService.distributionTimeRange;
    //Widget
    this.GetDeviceCountByUser();
    this.selectedDeviceStatus = 2;
    this.GetDeviceCountByStatus();
    this.GetGroupByUserAndDeviceStatus();
    this.alarmsByDeviceStockConfig = this.statsService.alarmsByDeviceOverTimeStockConfig;
    this.CreateAllCharts();

    this.statsService.colChartClicked$.subscribe(data => {
      if (data) {
        if (!this.columnChart.fullscreen.isOpen) {
          document.body.style.overflow = 'hidden';
          this.isDialogLoading = true;
          this.showInfoDialog = true;
          this.colChartClick = true;
          this.stockChartClick = false;
          this.pieChartClick = false;
          const selectedStatus = this.status.find(p => p.color === data.point.color);
          this.SelectedDeviceName = data.point.category;
          this.SelectedSeverityName = selectedStatus.status;
          this.GetDeviceAlarmsDetails({
            "deviceId": this.deviceList.find(p => p.name === data.point.category).id,
            "status": (selectedStatus.id === 3) ? 2 : selectedStatus.id,
            "isActive": (selectedStatus.id === 3) ? false : true
          }, true, false, false);
        }
        else {
          document.body.style.overflow = 'auto';
        }
      }
    });
    this.statsService.pieChartClicked$.subscribe(data => {
      if (data) {
        if (!this.pieChart.fullscreen.isOpen) {
          this.isDialogLoading = true;
          document.body.style.overflow = 'hidden';
          this.showInfoDialog = true;
          this.colChartClick = false;
          this.stockChartClick = false;
          this.pieChartClick = true;
          const selectedStatus = this.status.find(p => p.status === data.name);
          this.SelectedSeverityName = selectedStatus.status;
          this.GetDeviceAlarmsDetails({
            "status": (selectedStatus.id === 3) ? 2 : selectedStatus.id,
            "isActive": (selectedStatus.id === 3) ? false : true
          }, false, true, false);
        }
        else {
          document.body.style.overflow = 'auto';
        }
      }
    });
    this.statsService.stockChartClicked$.subscribe(data => {
      if (!this.stockChart.fullscreen.isOpen) {
        this.isDialogLoading = true;
        document.body.style.overflow = 'hidden';
        this.showInfoDialog = true;
        this.colChartClick = false;
        this.stockChartClick = true;
        this.pieChartClick = false;
        const selectedStatus = this.status.find(p => p.color === data.color);
        const dt = new Date(data.category);
        if (dt !== undefined) {
          this.selectedStockChartDate = UtilService.DateWithFormat(new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate(), dt.getUTCHours(), dt.getUTCMinutes(), dt.getUTCSeconds()), 'yyyy-MM-dd HH:mm:ss a')
          this.GetDeviceAlarmsDetails({
            "status": (selectedStatus.id === 3) ? 2 : selectedStatus.id,
            "selectedDate": this.selectedStockChartDate,
            "isActive": (selectedStatus.id === 3) ? false : true
          }, false, false, true);
        }
      }
      else {
        document.body.style.overflow = 'auto';
      }
    });
  }

  GetDeviceAlarmsDetails(data: any, fromBarChar, fromPieChart, fromStockChart) {
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    const endDate = UtilService.FormatDate(new Date());
    let startDate = null;
    if (fromBarChar) {
      startDate = UtilService.FormatDate(new Date(new Date().getTime() - ((this.colChrtslctedDtRng) * 24 * 60 * 60 * 1000)))
      this.statsService.GetAlarmDataForBarchartClick(data.deviceId, data.status, data.isActive, startDate, endDate).subscribe(response => {
        this.bindAlarmGrid(response);
      });
    } else if (fromPieChart) {
      startDate = UtilService.FormatDate(new Date(new Date().getTime() - ((this.pieChrtslctedDtRng) * 24 * 60 * 60 * 1000)))
      this.statsService.GetAlarmDataForPiechartClick(deviceFilter, data.status, data.isActive, startDate, endDate).subscribe(response => {
        this.bindAlarmGrid(response);
      });
    } else if (fromStockChart) {
      this.statsService.GetDataForAlarmStockChartClick(deviceFilter, data.status, data.isActive, data.selectedDate).subscribe(response => {
        this.bindAlarmGrid(response);
      });
    } else {
      //empty condition block
    }
  }
  bindAlarmGrid(result: any) {
    this.alarmsData = []
    if (result.length === 0) {
      this.noDataAlarmInfo = true;
      this.isPagination = false;
    }
    else {
      this.isPagination = result.length >= 10;
      this.alarmsData = result;
    }
    this.isDialogLoading = false;
  }

  //1st block
  GetDeviceCountByUser() {
    this.deviceCountWLoader = true;
    this.statsService.GetDeviceCountByUser().subscribe(result => {
      this.deviceCount = result.value;
      this.deviceCountWLoader = false;
    });
  }
  //2nd
  GetDeviceCountByStatus() {
    this.deviceCountStatusWLoader = true;
    this.deviceStatusCount = null;
    this.statsService.GetDeviceCountByStatus(this.selectedDeviceStatus).subscribe(result => {
      this.deviceStatusCount = result.value;
      this.deviceCountStatusWLoader = false;

    });
  }
  DeviceStatusCountChange($event) {
    this.deviceGroupCount = '';
    this.GetDeviceCountByStatus();
    this.GetGroupByUserAndDeviceStatus();
    this.CreateAllCharts();
  }
  //3nd & 4th block
  GetGroupByUserAndDeviceStatus() {
    this.groupCountWLoader = true;
    this.selectedDeviceGroup = []
    this.deviceGroupNames = []
    this.statsService.GetGroupByUserAndDeviceStatus(this.selectedDeviceStatus).subscribe(result => {
      this.deviceGroupCount = result.length-1;
      if (result && result.length > 0) {
        const arr = result.map((row) => ({ id: row.key, name: row.value }));
        this.deviceGroupNames = this.getUniqueListBy(arr, 'id')
        this.isGroupPagination = result.length >= 10;
        this.deviceGroupNames.map((item) => this.selectedDeviceGroup.push(item));
        this.GetControllerTypeByGroups();
      } else {
        this.contrlModels = []
        this.selectedcontrlModel = [];
        this.noDataDeviceGroupGridInfo = true;
        this.isGroupPagination = false;
      }
      this.CreateAllCharts();
      this.groupCountWLoader = false;
    });
  }
  GroupDetails() {
    this.isGroupModalLoading = true;
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    this.statsService.GetGroupsByGroupIdsAndDeviceStatus(deviceFilter).subscribe(result => {
      document.body.style.overflow = 'hidden';
      this.showGroupDeviceInfoDialog = true;
      result.forEach((item) => {
        item.deviceCount = item.deviceIds.length;
      });
      this.GroupDetailsList = result;
      this.isGroupModalLoading = false;
    });

  }
  GetDeviceByGroup(groupId: number) {
    this.isGroupModalLoading = true;
    this.coolersData = [];
    this.statsService.GroupDeviceInfoByDeviceStatus(groupId, this.selectedDeviceStatus).subscribe(result => {
      if (result.length === 0) {
        this.isDeviceGroupPagination = false;
      }
      else {
        this.isDeviceGroupPagination = result.length >= 10;
        this.coolersData = result;
      }
      this.isGroupModalLoading = false;
    });
  }
  //4th block
  DeviceByGroupCountChange($event) {
    this.GetControllerTypeByGroups();
    this.CreateAllCharts();
  }
  //5th block
  GetControllerTypeByGroups() {
    this.contrlModels = []
    this.selectedcontrlModel = [];
    const selectedGroupIds = this.selectedDeviceGroup.map(item => item.id);
    this.statsService.GetControllerTypeByGroups(selectedGroupIds, this.selectedDeviceStatus).subscribe(result => {
      if (result && result.length > 0) {
        const arr = result.map((row) => ({ id: row.key, name: row.value }))
        this.contrlModels = this.getUniqueListBy(arr, 'id')
        this.contrlModels.map((item) => this.selectedcontrlModel.push(item));
        this.CreateAllCharts();
      }
    });
  }
  getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }
  ControllerTypeByGroupsChange($event) {
    this.CreateAllCharts();
  }
  //All graph function
  CreateAllCharts() {
    this.GetAlarmCountGroupByStatusDevice(this.colChrtslctedDtRng)
    this.GetAlarmGroupByStatus(this.pieChrtslctedDtRng);
    this.GetAlarmDistributionData(this.distChrtslctedDtRng);
    this.GetDataForAlarmStockChart();
  }
  //6 block

  GetAlarmCountGroupByStatusDevice(range) {
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    const endDate = UtilService.DateWithFormat(new Date(), this.labels.dateFormat);
    const startDate = UtilService.DateWithFormat(new Date(new Date().getTime() - (range * 24 * 60 * 60 * 1000)), this.labels.dateFormat);
    this.statsService.GetDataForStatisticsBarChart(deviceFilter, startDate, endDate).subscribe(result => {
      let series = result.data;
      this.deviceList = result.category;
      series = series.map(item => ({ ...item, type: undefined }));
      const xAxisCategory = result.category.map(item => item.name);
      this.deviceStatusCountBarconfig = this.statsService.GetdeviceStatusCountColumnChartConfig(series, xAxisCategory);
      this.columnChart = Highcharts.chart('bar', this.deviceStatusCountBarconfig);
    });
  }
  colChrtslctedDtRngChange($event) {
    this.GetAlarmCountGroupByStatusDevice(this.colChrtslctedDtRng);
  }
  //7th block
  pieChrtslctedDtRngChange($event) {
    this.GetAlarmGroupByStatus(this.pieChrtslctedDtRng)
  }
  GetAlarmGroupByStatus(range) {
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    const endDate = UtilService.DateWithFormat(new Date(), this.labels.dateFormat);
    const startDate = UtilService.DateWithFormat(new Date(new Date().getTime() - (range * 24 * 60 * 60 * 1000)), this.labels.dateFormat);
    this.statsService.GetDataForStatisticsPieChart(deviceFilter, startDate, endDate).subscribe(result => {
      const data = [{
        name: 'Critical',
        y: result.criticalAlarmCount
      }, {
        name: 'Warning',
        y: result.warningAlarmCount
      }, {
        name: 'Clear',
        y: result.clearedAlarmCount
      }]
      this.deviceByGroupPieChartConfig = this.statsService.getdeviceByGroupPieChartConfig;
      this.deviceByGroupPieChartConfig.series[0]["data"] = data;
      this.pieChart = Highcharts.chart('pie', this.deviceByGroupPieChartConfig);
    });
  }
  //8th block

  GetAlarmDistributionData(range) {
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    this.statsService.GetDataForAlarmRadarChart(deviceFilter, range).subscribe(result => {
      this.AlarmsCountByDistriConfig = this.statsService.GetAlarmsCountByDistriConfig(result.labels, result.data);
      this.distributionChart = Highcharts.chart('alarmDistribution', this.AlarmsCountByDistriConfig);
    });
  }
  distChrtslctedDtRngChange($event) {
    this.GetAlarmDistributionData(this.distChrtslctedDtRng);
  }
  //9th block

  GetDataForAlarmStockChart() {
    const deviceFilter = {
      DeviceStatus: this.selectedDeviceStatus,
      GroupIds: this.selectedDeviceGroup.map(item => item.id),
      ControllerTypeIds: this.selectedcontrlModel.map(item => item.id)
    }
    this.statsService.GetDataForAlarmStockChart(deviceFilter).subscribe(data => {
      this.alarmsByDeviceStockConfig.series = data;
      this.stockChart = Highcharts.stockChart('stock', this.alarmsByDeviceStockConfig);
    });
  }

  CloseModal() {
    this.alarmsData = []
    this.showInfoDialog = false;
    this.showGroupDeviceInfoDialog = false;
    document.body.style.overflow = 'auto';
  }
  
  parseValue(value: string): number {
    return parseInt(value, 10); 
  }
}
